import { Box, Typography } from '@mui/material';
import FactoryIcon from '@mui/icons-material/Factory';
import { useTheme } from '@mui/material';

interface FormHeaderProps {
  mode: 'create' | 'edit';
}

export function FormHeader({ mode }: FormHeaderProps) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <FactoryIcon sx={{ color: theme.palette.primary.main, fontSize: 36 }} />
      <Box>
        <Typography variant="h4" fontWeight={800} color={theme.palette.text.primary} mb={0.5}>
          {mode === 'create' ? 'Novo Fabricante' : 'Editar Fabricante'}
        </Typography>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Preencha as informações do fabricante de equipamentos.
        </Typography>
      </Box>
    </Box>
  );
} 